import { FlattenArea } from 'store/slices/TreeSlice';

enum EditType {
  TREE = 'TREE',
  FLATTEN_AREA = 'FLATTEN_AREA',
}

// BE only accepts these 2; 'free' is normalized to 'polygon' before the wire (useEditDsm.ts).
enum FlattenAreaWireShape {
  Polygon = 'polygon',
  Circle = 'circle',
}

// Tree edits go over the wire as `TreeType` (trunkHeight, not the local
// editing model's treeHeight) — see store/slices/TreeSlice's `Tree` type.
type CreateEditPayload =
  | {
      type: EditType.TREE;
      edits: TreeType;
    }
  | {
      type: EditType.FLATTEN_AREA;
      edits: Omit<FlattenArea, 'id'| 'flat_px'| 'facet_affected_px'| 'ground_z'| 'shape'> & {
        shape?: FlattenAreaWireShape;
      };
    };

type UpdateEditPayload =
  | {
      id: number;
      type: EditType.TREE;
      edits: Partial<TreeType>;
    }
  | {
      id: number;
      type: EditType.FLATTEN_AREA;
      edits: Partial<Omit<FlattenArea, 'id'| 'shape'>> & { shape?: FlattenAreaWireShape };
    };

type EditDSMPayload = {
  uuid: string;
  create?: CreateEditPayload[];
  update?: UpdateEditPayload[];
  delete?: number[];
}

type PreviewFlattenPayload = {
	uuid: string;
	coords: number[][];
} 

export { EditType, FlattenAreaWireShape };
export type {
	EditDSMPayload,
	CreateEditPayload,
	UpdateEditPayload,
	PreviewFlattenPayload
};
